import React, { Fragment, Component } from "react"
import { Route } from "react-router-dom"
import { connect } from "react-redux"
import { translate } from "react-i18next"
import compose from "ramda/src/compose"
import find from "ramda/src/find"
import Toolbar from "shared/components/Toolbar"
import Link from "shared/components/Link"

import { logout, saveOperation } from "services/state/actions"
import { SIN } from "services/state/billing/constants"
import iconLogo from "assets/svg/algar-telecom-logo.svg"
import iconNotification from "assets/svg/notification.svg"
import Logout from "shared/assets/svg/icon-exit.svg"
import Menu from "./components/Menu"
import Notification from "./components/Notification"
import styles from "./styles.css"
import NotificationUser from "./components/NotificationUser"
import * as PropTypes from "prop-types"

class Masthead extends Component {
  state = {
    tableContainer: null,
    tableContainerUser: null,
    showError: false
  }

  setTableContainer = (node) => {
    if (!this.state.tableContainer) {
      this.setState({ tableContainer: node })
    }
  }

  setTableContainerUser = (node) => {
    if (!this.state.tableContainerUser) {
      this.setState({ tableContainerUser: node })
    }
  }

  registerExperience = () => {
    this.props.saveOperation(
      this.props.customer,
      "",
      "LOGIN",
      "OLD_VERSION",
      "SUCCESS",
      "",
      "Login Manual"
    )

    setTimeout(() => {
      window.location.href = "/AreaCliente/portal-usuario/index.html"
    }, 300)
  }

  canRedirectToPreviousVersion() {
    const { bills } = this.props

    const blockRedirect = "IOT"

    let productsIot = []

    if (bills) {
      productsIot = bills.filter((bill) => {
        if (typeof bill.products === "string") {
          const typeProduct = bill.products.trim().split(";")[0]
          return typeProduct === blockRedirect
        }
        return false
      })
    }

    return (
      bills &&
      !productsIot.length &&
      !!find((bill) => bill.targetCrm !== SIN, bills)
    )
  }

  rederErrorBox() {
    return (
      <div className={styles.erroBox}>
        <div className={styles.erroBoxWrapper}>
          <p className={styles.errorTextWrapper}>
            <img
              src={iconNotification}
              alt=""
              className={styles.iconNotification}
            />
            Desculpe! O acesso às faturas está indisponível devido a uma
            manutenção para melhorarmos sua experiência. Em até 24h essa
            funcionalidade estará de volta.
          </p>
        </div>
      </div>
    )
  }

  render() {
    const { t, logout } = this.props

    return (
      <header className={styles.masthead}>
        <Toolbar>
          <div className={styles.navigation}>
            <h1 className={styles.logo}>
              <Link to="/" weight="fit">
                <img
                  src={iconLogo}
                  alt="Algar Telecom"
                  width="92"
                  height="36"
                />
              </Link>
            </h1>

            <ul>
              <li>
                <form ref={this.setTableContainer}>
                  <Menu container={this.state.tableContainer} />
                </form>
              </li>

              <li className={styles.md}>
                <Link
                  to="/products-plant"
                  onClick={() =>
                    this.onClick("PRODUCTS_PLANT", "Planta de Produtos")
                  }
                >
                  {t("MSG_0001")}
                </Link>
              </li>
            </ul>
          </div>

          <div className={styles.identification}>
            <form ref={this.setTableContainerUser} className={styles.formUser}>
              <button onClick={logout} className={styles.btnLogout}>
                <i className={styles.icon}>
                  <img src={Logout} alt="" />
                  <span>Sair</span>
                </i>
              </button>
            </form>
          </div>
        </Toolbar>

        <Route
          exact
          path="/"
          render={() => (
            <Fragment>
              {this.state.showError && this.rederErrorBox()}
              <div className={styles.notificationWrapper}>
                <Notification />
              </div>
              <div className={styles.notificationWrapper}>
                <NotificationUser />
              </div>
            </Fragment>
          )}
        />
      </header>
    )
  }
}

Masthead.propTypes = {
  saveOperation: PropTypes.func,
  logout: PropTypes.func,
  customer: PropTypes.object,
  bills: PropTypes.array,
  t: PropTypes.func
}

const mapStateToProps = ({ customer, bills }) => ({
  bills: bills.data,
  customer: customer.data
})

const enhance = compose(
  translate(),
  connect(mapStateToProps, { logout, saveOperation })
)

export default enhance(Masthead)



// WEBPACK FOOTER //
// ./src/components/Masthead/index.js